import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import { Season, TeamSource, Team } from '../../models'
import template from './edit-team-source.jade'
import emitter from '@scoutgg/ftw/source/services/emitter'

const prices = Symbol('prices')

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('team', Team)

export default class EditTeamSource extends HTMLElement {
  attached() {
    this.update(TeamSource.load({ season: this.season._id, $reload: true }))
    this.render()
  }

  customSource(team) {
    return (this.customSources || []).find(s => s.team === team)
  }

  toggleDisabled(team, e) {
    team.notAvailable = e.checked
  }

  closeModal(save) {
    if(this.team._id < 0) {
      delete this.team._id
    }
    if(save) emitter.emit('team:edited', { team: this.team })
    this.parentNode.close({ team: this.team })
  }
}
